import {
	Component,
	ElementRef,
	Input,
	OnInit,
	signal,
	ViewChild
} from '@angular/core';
import {
	ControlContainer,
	FormGroup,
	FormGroupDirective,
	ReactiveFormsModule
} from '@angular/forms';
import { DatepickerDirective } from '../../../shared/directives';
import { CapitalFirstPipe } from '../../../shared/pipes/capital-first.pipe';
import { FormField } from '../../../core/models/form/form-field.model';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
	selector: 'app-form-input',
	imports: [
		ReactiveFormsModule,
		DatepickerDirective,
		CapitalFirstPipe,
		NgSelectModule
	],
	viewProviders: [
		{
			provide: ControlContainer,
			useExisting: FormGroupDirective
		}
	],
	templateUrl: './form-input.component.html',
	styleUrl: './form-input.component.scss'
})
export class FormInputComponent implements OnInit {
	@Input() inputItem!: FormField;
	@ViewChild('colorPicker') colorPicker: ElementRef | undefined;
	displayColorValue: string = '#D100000';

	showPassword = signal(false);

	constructor(private controlContainer: ControlContainer) {}

	ngOnInit() {
		if (this.inputItem && this.inputItem.type === 'color-picker') {
			const initialColor = this.formGroup.get(this.inputItem.id)?.value;
			if (initialColor) {
				this.displayColorValue = initialColor;
			}
		}
	}

	getFieldErrors(fieldName: string): string[] {
		const control = this.formGroup.get(fieldName);

		if (control && control.invalid && (control.dirty || control.touched)) {
			return Object.keys(control.errors || {}).map(
				key =>
					this.inputItem.errorMessages?.[key] || `Errore di validazione: ${key}`
			);
		}

		return [];
	}

	isRequired(fieldName: string): boolean {
		const control = this.formGroup.get(fieldName);
		if (!control || !control.validator) return false;

		const validator = control.validator({} as any);
		return validator && validator['required'];
	}

	updateColorDisplay(event: any) {
		this.displayColorValue = event.target.value;
	}

	get formGroup() {
		return this.controlContainer.control as FormGroup;
	}

	onInputChange(event: any, inputItem: FormField) {
		const control = this.formGroup.get(inputItem.id);
		if (!control) return;

		let value = event.target.value;

		if (inputItem.toUppercase) {
			value = value.toUpperCase();
		}

		control.setValue(value, { emitEvent: false });
	}
}